import { useMemo } from 'react';

export type ChatMessageBubbleLayout = 'attachment-only' | 'mixed' | 'text-only';

type P = {
  hasAttachments: boolean;
  hasText: boolean;
};

export const useChatMessageBubbleLayout = ({ hasAttachments, hasText }: P): ChatMessageBubbleLayout =>
  useMemo(() => {
    if (hasAttachments && hasText) {
      return 'mixed';
    }
    if (hasAttachments) {
      return 'attachment-only';
    }
    return 'text-only';
  }, [hasAttachments, hasText]);
